import { ENDPOINTS } from "../../apiConfig";
import { showToast } from "../../../components";
import { getResponseMessage } from "../../../utils";
import axiosRequest from "../universal/axiosService";

// export const getTotalCountApi = async ({ collection, coll, filters }) => {
//   try {
//     //console.log("getTotalCountApi", collection, coll, filters);

//     const token = localStorage.getItem("token");
//     const response = await axios.get(
//       `${ENDPOINTS.GET_TOTAL_COUNT}/${collection}/getTotalCount`,
//       {
//         params: {
//           coll: coll,
//           fil: JSON.stringify(filters),
//         },
//         headers: {
//           //Authorization: `Bearer ${token}`,
//           "Content-Type": "application/json",
//         },
//         withCredentials: true,
//       }
//     );
//     return response.data;
//   } catch (error) {
//     showToast(getResponseMessage(error), "error");
//   }
// };
export const getTotalCountApi = async (params) => {
  const { collection, coll, filters, app = "workforce", errorHandler = false } = params;
  //console.log("getTotalCountApi", params);

  try {
  return await axiosRequest({
    method: "GET",
    // url: `${app==="workforce"?ENDPOINTS.GET_TOTAL_COUNT:ENDPOINTS.GET_TOTAL_COUNT_ATS}/${collection}/getTotalCount`,
    url: `${
      app === "workforce"
        ? ENDPOINTS.GET_TOTAL_COUNT
        : app === "ats"
        ? ENDPOINTS.GET_TOTAL_COUNT_ATS
        : app === "bs"
        ? ENDPOINTS.GET_TOTAL_COUNT_BENCHSALES
        : ENDPOINTS.GET_TOTAL_COUNT_MASTER
    }/${collection}/getTotalCount`,

    params: {
      coll,
      fil: JSON.stringify(filters),
       useAggregate: params.useAggregate|| false,
       ...(errorHandler && {errorHandler})
    },
  })
}
  catch (error) {
    console.log("Error in getTotalCountApi:", error); 
  }
};


// export const getTotalCountApi = async ({ collection, coll, filters }) => {
//   try {
//     const token = localStorage.getItem("token");
//     const response = await axios.get(
//       `${ENDPOINTS.GET_TOTAL_COUNT}/${collection}/getTotalCount`,
//       {
//         params: {
//           coll: coll,
//           fil: JSON.stringify(filters),
//         },
//         headers: {
//           Authorization: `Bearer ${token}`,
//           "Content-Type": "application/json",
//         },
//         withCredentials: true,
//       }
//     );
//     return response.data;
//   } catch (error) {
//     showToast(getResponseMessage(error), "error");
//   }
// };
